import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

export default function ComingSoonPage({ setPage }) {
  return (
    <div className="relative w-full min-h-[75vh] flex flex-col items-center lg:pt-[200px] justify-center text-center px-6 py-20 overflow-hidden bg-[#fafcff]">

      {/* Premium ambient background blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute top-1/3 left-1/3 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-navy/5 rounded-full blur-[100px] pointer-events-none" />

      {/* Floating Icon Container */}
      <div className="relative mb-10">
        <div className="w-[100px] h-[100px] rounded-2xl bg-white flex items-center justify-center shadow-[0_24px_48px_rgba(14,36,62,0.08)] relative z-10 border border-black/5 cursor-default">
          <Sparkles className="text-gold" size={44} strokeWidth={1.5} />
        </div>
        <div className="absolute -inset-2 bg-gradient-to-tr from-gold/20 to-transparent rounded-2xl blur-xl -z-10 opacity-70" />
      </div>

      {/* Main Title */}
      <h1 className="relative m-0 font-heading font-bold text-[56px] md:text-[72px] leading-[1.2] pb-2 tracking-[-0.02em] mb-4 text-transparent bg-clip-text uppercase" style={{ backgroundImage: 'linear-gradient(135deg, #0e243e 0%, #061D51 100%)' }}>
        Coming Soon
      </h1>

      {/* Subtitle */}
      <p className="relative max-w-[480px] text-[18px] md:text-[20px] leading-[1.6] text-ink/60 mb-12 font-light">
        We are crafting something extraordinary for you. This section of our website will be available shortly.
      </p>

      {/* Sleek Button */}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          if (setPage) setPage('home');
        }}
        className="flex items-center h-[46px] px-[26px] rounded-[3px] bg-navy text-white text-[12.5px] font-bold tracking-widest uppercase transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
      >
        Back to Home
      </a>

    </div>
  );
}
